import CircularProgress from '@material-ui/core/CircularProgress';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import * as React from 'react';

interface IListItemLoadingProps {
  style?: React.CSSProperties;
  label?: string;
}

let ListItemLoading: React.FunctionComponent<IListItemLoadingProps> = ({ style, label = 'Loading...' }) => (
  <ListItem style={style ? style : undefined}>
    <ListItemIcon>
      <CircularProgress />
    </ListItemIcon>
    <ListItemText primary={label} />
  </ListItem>
);

ListItemLoading = React.memo(ListItemLoading);
export { ListItemLoading };
